import { useRuntimeConfig } from "#imports";
import { defineAsyncComponent, hydrateOnVisible } from "vue";
export default function useBoosterHydrate() {
  return (component, hydrate) => {
    const runtimeConfig = useRuntimeConfig();
    if (!(isDev || import.meta.server) && typeof component === "function") {
      hydrate = hydrate || hydrateOnVisible({
        rootMargin: runtimeConfig.public.booster.lazyOffsetComponent || "0%"
      });
    } else {
      hydrate = void 0;
    }
    return defineAsyncComponent({
      loader: component,
      hydrate
    });
  };
}
const isDev = process.env.NODE_ENV === "development";
